import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HedgePresetDesignerComponent} from './hedge-preset-designer.component';
import {HedgePresetSelectorComponent} from './hedge-preset-selector.component';
import {HedgePresetLauncherComponent} from './hedge-preset-launcher.component';
import {DevExtremeModule} from '../devextreme.module';
import {EtsSymbolPickerModule} from '../symbol-picker/symbol-picker.module';
@NgModule({imports: [CommonModule, FormsModule, DevExtremeModule, EtsSymbolPickerModule],
    declarations: [HedgePresetDesignerComponent, HedgePresetSelectorComponent, HedgePresetLauncherComponent],
    exports: [HedgePresetDesignerComponent, HedgePresetSelectorComponent, HedgePresetLauncherComponent]})
export class HedgePresetsModule {}
